import React from "react";

const styles = {
    textAlign: 'center'
}

function Footer() {
    return (
        <footer>
           <div style={styles}>Made With Love by Us</div>
        </footer>
    )
}

export default Footer